"use client";
import React, {useRef} from "react";
import {motion, MotionValue, useScroll, useTransform} from "framer-motion";

export const ContainerScroll = ({
                                    titleComponent,
                                    children,
                                }: {
    titleComponent: string | React.ReactNode;
    children: React.ReactNode;
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const {scrollYProgress} = useScroll({
        target: containerRef,
        offset: ["start start", "end end"],
    });

    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => {
            window.removeEventListener("resize", checkMobile);
        };
    }, []);

    const scaleDimensions = () => {
        return isMobile ? [0.7, 0.9] : [1.05, 1];
    };

    // Increase animation intensity
    const rotate = useTransform(scrollYProgress, [0, 1], [30, 0]);
    const scale = useTransform(scrollYProgress, [0, 1], scaleDimensions());
    const translate = useTransform(scrollYProgress, [0, 1], [0, -200]);

    return (
        <div
            className="min-h-[100vh] flex items-start justify-center relative pt-10"
            ref={containerRef}
        >
            <div
                className="w-full relative pt-10 md:pt-24"
                style={{
                    perspective: "1000px",
                }}
            >
                <Header translate={translate} titleComponent={titleComponent}/>
                <Card rotate={rotate} translate={translate} scale={scale}>
                    {children}
                </Card>
            </div>
        </div>
    );
};

export const Header = ({translate, titleComponent}: {
    translate: MotionValue<number>,
    titleComponent: React.ReactNode
}) => {
    return (
        <motion.div
            style={{
                translateY: translate,
            }}
            className="div max-w-5xl mx-auto text-center"
        >
            {titleComponent}
        </motion.div>
    );
};

export const Card = ({
                         rotate,
                         scale,
                         translate,
                         children,
                     }: {
    rotate: MotionValue<number>;
    scale: MotionValue<number>;
    translate: MotionValue<number>;
    children: React.ReactNode;
}) => {
    return (
        <motion.div
            style={{
                rotateX: rotate,
                scale,
                boxShadow:
                    "0 0 #0000004d, 0 9px 20px #0000004a, 0 37px 37px #00000042, 0 84px 50px #00000026, 0 149px 60px #0000000a, 0 233px 65px #00000003",
            }}
            className="


      max-w-5xl mt-20 mx-auto h-[30rem] md:min-h-[500px] md:h-[40rem] w-full rounded-[30px] bg-transparent shadow-1xl mb-48"
        >
            <div className="h-full w-full overflow-hidden rounded-2xl  p-0">
                {children}
            </div>
        </motion.div>
    );
};